// Single source of truth for sidebar navigation.
// App.jsx renders it, Dashboard.jsx lists it and the mock contract
// (GET /api/qa/navigation) returns it, so the navigation audit can verify parity.
export const overviewItem = { path: "/", label: "Overview", icon: "bi-grid-1x2-fill" };

export const modules = [
  { path: "/api-client", label: "Shared API Client", icon: "bi-diagram-3" },
  { path: "/auth-session", label: "Auth / Session", icon: "bi-shield-lock" },
  { path: "/api-errors", label: "API Error Mapping", icon: "bi-exclamation-triangle" },
  { path: "/form-states", label: "Form Request / Response", icon: "bi-ui-checks-grid" },
  { path: "/pagination", label: "Pagination & Filters", icon: "bi-funnel" },
  { path: "/async-loading", label: "Async Loading", icon: "bi-arrow-repeat" },
  { path: "/empty-error-states", label: "Empty / Error States", icon: "bi-inbox", isNew: true },
  { path: "/permission-denied", label: "Permission Denied", icon: "bi-shield-x", isNew: true },
  { path: "/tenant-context", label: "Tenant Context", icon: "bi-building-check", isNew: true },
  { path: "/responsive-audit", label: "Responsive Breakpoints", icon: "bi-arrows-angle-expand", isNew: true },
  { path: "/sidebar-audit", label: "Sidebar Responsive Audit", icon: "bi-layout-sidebar", isNew: true }
];
